import React, { useState, createContext } from "react"

export const ConclusionContext = createContext({
    fetchingConclusions: false,
    setFetchingConclusions: () => {},

    conclusions: [],
    setConclusions: () => {},

    contentFromConclusions: [],
    setContentFromConclusions: () => {},

    currentConclusion: null,
    setCurrentConclusion: () => {}
})

export default function ConclusionProvider(props) {
    const { children } = props
    const [fetchingConclusions, setFetchingConclusions] = useState(false)
    const [currentConclusion, setCurrentConclusion] = useState([])
    const [contentFromConclusions, setContentFromConclusions] = useState([])
    const [conclusions, setConclusions] = useState(null)

    useEffect(() => {
        console.log({ currentConclusion })
    }, [currentConclusion])

    return (
        <ConclusionContext.Provider
            value={{
                fetchingConclusions,
                setFetchingConclusions,

                currentConclusion,
                setCurrentConclusion,

                conclusions,
                setConclusions,

                contentFromConclusions,
                setContentFromConclusions
            }}
        >
            {children}
        </ConclusionContext.Provider>
    )
}
